export const UPDATE_GENRES_LIMIT = 'UPDATE_GENRES_LIMIT'
